export { default } from './ForbiddenError';
export type { ForbiddenErrorProps } from './ForbiddenError';
export { default as ForbiddenErrorPage } from './ForbiddenErrorPage';
